(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-cart"]) return;
  try {
    

(() => {
  const resetCart = (form) => {
    delete form.dataset.veraneSubmitting;
    form.classList.remove('is-updating');
    form.removeAttribute('aria-busy');
  };
  const initCart = () => {
    document.querySelectorAll('[data-verane-cart-form]').forEach((form) => {
      if (form.dataset.veraneCartReady === 'true') return;
      form.dataset.veraneCartReady = 'true';
      form.classList.add('is-enhanced');
      const submitCart = () => {
        if (form.dataset.veraneSubmitting === 'true' || !form.reportValidity()) return;
        const updateButton = form.querySelector('button[name="update"]');
        if (typeof form.requestSubmit === 'function') form.requestSubmit(updateButton);
        else form.submit();
      };
      form.addEventListener('submit', (event) => {
        if (form.dataset.veraneSubmitting === 'true') { event.preventDefault(); return; }
        form.dataset.veraneSubmitting = 'true';
        form.classList.add('is-updating');
        form.setAttribute('aria-busy', 'true');
      });
      form.addEventListener('click', (event) => {
        const button = event.target.closest('[data-verane-cart-step]');
        if (!button || !form.contains(button) || form.dataset.veraneSubmitting === 'true') return;
        const input = button.closest('[data-verane-cart-stepper]').querySelector('[data-verane-cart-quantity]');
        const current = Number.parseInt(input.value, 10);
        if (!Number.isFinite(current)) { input.reportValidity(); return; }
        const next = Math.max(0, current + Number(button.dataset.veraneCartStep));
        if (next === current) return;
        input.value = String(next);
        submitCart();
      });
      form.addEventListener('change', (event) => {
        if (!event.target.matches('[data-verane-cart-quantity]')) return;
        submitCart();
      });
    });
  };
  initCart();
  document.addEventListener('shopify:section:load', initCart);
  window.addEventListener('pageshow', () => {
    document.querySelectorAll('[data-verane-cart-form]').forEach(resetCart);
    initCart();
  });
})();


  } catch(e) { console.error(e); }
})();
})();
